import { render, staticRenderFns } from "./Archive_QuotationsAndInvoices.vue?vue&type=template&id=4d9abde8&"
import script from "./Archive_QuotationsAndInvoices.vue?vue&type=script&lang=js&"
export * from "./Archive_QuotationsAndInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports